"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const webapi_1 = require("@fegobull/webapi");
const vue_demi_1 = require("vue-demi");
const utils_1 = require("../../common/utils");
const { useTeleport } = webapi_1.use;
useTeleport(document.body);
exports.default = (0, vue_demi_1.defineComponent)({
    name: 'TimeSlotPopup',
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        value: {
            type: String,
            default: ''
        },
        options: {
            type: Array,
            required: true
        }
    },
    emits: ['update:visible', 'confirm', 'cancel'],
    setup(props, { emit }) {
        const contentRef = (0, vue_demi_1.ref)(null);
        const itemRefs = (0, vue_demi_1.ref)(new Map());
        const tempValue = (0, vue_demi_1.ref)(props.value);
        // 多语言文本
        const lang = (0, utils_1.getCurrentLang)();
        const cancelText = (0, vue_demi_1.computed)(() => {
            const texts = {
                0: '取消', // CN
                1: '取消', // HK
                2: 'Cancel', // EN
                5: 'キャンセル' // JA
            };
            return texts[lang] || texts[0];
        });
        const confirmText = (0, vue_demi_1.computed)(() => {
            const texts = {
                0: '确认', // CN
                1: '確認', // HK
                2: 'Confirm', // EN
                5: '確認' // JA
            };
            return texts[lang] || texts[0];
        });
        // 设置选项引用
        const setItemRef = (el, value) => {
            if (el) {
                itemRefs.value.set(value, el);
            }
        };
        // 处理选项点击
        const handleItemClick = (item) => {
            if (item.disabled) {
                return;
            }
            tempValue.value = item.value;
        };
        // 滚动到选中的项
        const scrollToSelected = () => {
            if (!contentRef.value || !tempValue.value) {
                return;
            }
            const item = itemRefs.value.get(tempValue.value);
            if (item && contentRef.value) {
                item.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
        };
        // 处理确认
        const handleConfirm = () => {
            emit('confirm', tempValue.value);
            emit('update:visible', false);
        };
        // 处理取消
        const handleCancel = () => {
            tempValue.value = props.value;
            emit('cancel');
            emit('update:visible', false);
        };
        // 监听 visible 变化，初始化选择
        (0, vue_demi_1.watch)(() => props.visible, (newVal) => {
            if (newVal) {
                tempValue.value = props.value;
                (0, vue_demi_1.nextTick)(() => {
                    scrollToSelected();
                });
            }
            else {
                // 关闭时清理引用
                itemRefs.value.clear();
            }
        }, { immediate: true });
        // 监听 value 变化
        (0, vue_demi_1.watch)(() => props.value, (newVal) => {
            tempValue.value = newVal;
        });
        return {
            contentRef,
            tempValue,
            cancelText,
            confirmText,
            setItemRef,
            handleItemClick,
            handleConfirm,
            handleCancel
        };
    }
});
//# sourceMappingURL=data:application/json;base64,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